import React, { useState } from 'react';
import { Card, CardContent, CardActionArea, Typography, IconButton, Grid, Modal, Button, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Link } from 'react-router-dom';

const CardBtn = ({ url = null, onClick = null, text, icon, background = '', link = null, iconSize = '' }) => {
  const [open, setOpen] = useState(false);

  const handleCardClick = () => {
    if (url) {
      setOpen(true);
    } else {
      onClick();
    }
  };

  const formatUrl = (url) => {
    if (url.includes('drive.google.com')) {
      return url.replace('/view', '/preview');
    }
    return url;
  };

  const handleClose = () => {
    setOpen(false);
  };

  const CloseBtnStyle = {
    position: 'absolute',
    top: '10px',
    left: '10px',
    background: 'black',
    borderRadius: '3px',
    border: '1px solid black',
  }

  return (
    <>
      <Card sx={{ background: background }}>
        <CardActionArea component={link ? Link : 'div'} to={link} onClick={handleCardClick}>
          <CardContent>
            <Grid container alignItems="center" spacing={1}>
              <Grid item>
                <IconButton size={iconSize} color="primary">
                  {icon}
                </IconButton>
              </Grid>
              <Grid item>
                <Typography variant="h6">{text}</Typography>
              </Grid>
            </Grid>
          </CardContent>
        </CardActionArea>
      </Card>
      {url && (
        <Modal open={open} onClose={handleClose}>
          <Box>
            <IconButton
              style={CloseBtnStyle}
              onClick={handleClose}
            >
              <CloseIcon />
            </IconButton>
            <iframe src={formatUrl(url)} style={{ width: '100%', height: '100vh', border: 'none' }}></iframe>
          </Box>
        </Modal>
      )}
    </>
  );
};

export default CardBtn;
